import React, { useId, useState } from 'react';
import clsx from 'clsx';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

export type AccordionProps = {
  title: string;
  open?: boolean;
  children: React.ReactNode;
  onOpened?: () => void;
};

export function Accordion({ title, children, open, onOpened }: AccordionProps) {
  const [isOpened, setIsOpened] = useState(open !== undefined ? open : false);
  const panelId = useId();

  return (
    <div className="py-3 text-left">
      <button
        type="button"
        aria-expanded={isOpened}
        aria-controls={panelId}
        onClick={() => {
          if (onOpened && !isOpened) {
            onOpened();
          }

          setIsOpened(!isOpened);
        }}
        className="flex w-full cursor-pointer justify-between text-neutral-70"
      >
        {title}{' '}
        <ChevronDownIcon
          className={clsx('mr-3 h-4', {
            'rotate-180': isOpened,
          })}
          aria-hidden="true"
        />
      </button>
      <div
        id={panelId}
        role="region"
        className={clsx('py-2', {
          hidden: !isOpened,
        })}
      >
        {children}
      </div>
    </div>
  );
}
